<template>
  <eg-b-form-checkbox-group
    class="export-options mt-2 bv-no-focus-ring"
    :checked="value"
    :options="options"
    name="export-options"
    :stacked="stacked"
    @change="handleExportChange"
  />
</template>

<script>
import { PLATFORMS } from "@/constants";
import i18n from "@/i18n/i18n";

const getAllOptionsTexts = () => [
  {
    label: i18n.t("essays.export.annotations"),
    descriptionClass: "small-text text-left text-secondary",
    description: i18n.t("essays.export.annotationsDescription"),
    value: "content",
  },
  {
    label: i18n.t("essays.comments"),
    descriptionClass: "small-text text-left text-secondary",
    description: i18n.t("essays.export.commentsDescription"),
    value: "comments",
  },
  {
    label: i18n.t("essays.feedbackReport"),
    descriptionClass: "small-text text-left text-secondary",
    description: i18n.t("essays.export.feedbackDescription"),
    descriptionCanvas: i18n.t("essays.export.attachedAsPdf"),
    value: "feedback",
  },
  {
    label: i18n.t("essays.grammarReport"),
    descriptionClass: "small-text text-left text-secondary",
    description: i18n.t("essays.export.grammarDescription"),
    descriptionCanvas: i18n.t("essays.export.attachedAsPdf"),
    value: "errors",
  },
  {
    text: i18n.t("essays.export.hideGrades"),
    value: "hideGrades",
  },
  {
    text: i18n.t("common.status"),
    value: "status",
  },
  {
    text: i18n.t("common.class"),
    value: "class",
  },
  {
    text: i18n.t("essays.export.essayName"),
    value: "name",
  },
  {
    text: i18n.t("essays.export.studentName"),
    value: "studentName",
  },
  {
    text: i18n.t("common.assignment"),
    value: "assignment",
  },
  {
    text: i18n.t("common.rubric"),
    value: "rubric",
  },
  {
    text: i18n.t("common.grade"),
    value: "grade",
  },
];

const getOption = (option, isCanvas) => {
  if (option.text) {
    return option;
  }
  return {
    html: `
    <div>
      <div>${option.label}</div>
      <div class='${option.descriptionClass}'>
        ${
          isCanvas && option.descriptionCanvas
            ? option.descriptionCanvas
            : option.description
        }
      </div>
    </div>
    `,
    value: option.value,
  };
};

const getFormattedOptions = (props) => {
  const { availableOptions, additionalOptions, isCanvas } = props;
  const formatted = {};

  const allOptionsTexts = getAllOptionsTexts();
  for (let index = 0; index < allOptionsTexts.length; index++) {
    const option = allOptionsTexts[index];
    if (availableOptions.some((item) => item === option.value)) {
      formatted[option.value] = getOption(option, isCanvas);
    }
  }

  if (additionalOptions.length) {
    additionalOptions.forEach((option) => {
      formatted[option.value] = getOption(option, isCanvas);
    });
  }

  return formatted;
};

export default {
  props: {
    availableOptions: {
      type: Array,
      default: () => ["content", "feedback", "errors", "hideGrades"],
    },

    value: {
      type: Array,
      default: () => [],
    },

    stacked: {
      type: Boolean,
      default: false,
    },

    platform: {
      type: String,
      default: "",
    },

    additionalOptions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isCanvas() {
      return this.platform === PLATFORMS.CANVAS;
    },
    options() {
      const formattedOptions = getFormattedOptions({
        availableOptions: this.availableOptions,
        additionalOptions: this.additionalOptions,
        isCanvas: this.isCanvas,
      });

      return this.availableOptions.map((key) => {
        return {
          disabled: this.value.length === 1 && this.value.includes(key),
          ...formattedOptions[key],
        };
      });
    },
  },

  methods: {
    handleExportChange(value) {
      this.$emit("input", value);
    },
  },
};
</script>
